import { DebugJson, DebugSection } from '../DebugSection';

export interface DialogStateSectionProps { searchTerm?: string }

export function DialogStateSection({ searchTerm }: DialogStateSectionProps): JSX.Element {
  const extra = (typeof window !== 'undefined' && window.__PCB_DEBUG_EXTRA__) || {};
  const dialog = extra['dialog'];
  const dialogStack = extra['dialogStack'];

  return (
    <DebugSection
      id="dialog"
      title="3. Active form / dialog state"
      searchTerm={searchTerm}
      defaultCollapsed={!dialog && !dialogStack}
    >
      {dialog ? (
        <DebugJson value={dialog} searchTerm={searchTerm} />
      ) : (
        <div className="pcb-debug-empty">
          No dialog currently registered. PersonDialog / EntityDialog / scan flows
          publish state via <code>window.__PCB_DEBUG_EXTRA__.dialog</code>.
        </div>
      )}
      {dialogStack ? (
        <details className="pcb-debug-details">
          <summary>modal stack</summary>
          <DebugJson value={dialogStack} searchTerm={searchTerm} />
        </details>
      ) : null}
    </DebugSection>
  );
}
